import {
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";
import TableMakeupWorkRequest from "./tableMakeupWorkRequest";
import { useMakeupWorkRequest } from "../../hooks/useMakeupWorkRequest";

export default function MakeupWorkRequest() {
  const { isRefetching } = useMakeupWorkRequest();

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý đăng ký làm bù
          </Text>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableMakeupWorkRequest isRefetchingWithCreate={isRefetching} />
      </Box>
    </Box>
  );
}
